<template>
	<form id="formFile">
		<div class="recording" v-if="musicRecording_control">
			<div>录制操作台</div>
			<samp class="samp_info" @click="startRecorder()">开始录音</samp>
			<samp class="samp_info" @click="playRecorder()">试听录音</samp>
			<samp class="samp_info" @click="upFile()">上传录音</samp>
		</div>
		<div style="line-height: 120px; text-align: center;" class="recording_1" v-else>
			你的手机微信版本过低，不支持语音录制
		</div>
	</form>
</template>

<script>
	import Recorder from 'js-audio-recorder'
	const lamejs = require('lamejs')
	const recorder = new Recorder({
		sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
		sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
		numChannels: 2, // 声道，支持 1 或 2， 默认是1
		// compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
	})

	// 绑定事件-打印的是当前录音数据
	recorder.onprogress = function(params) {
		// console.log('--------------START---------------')
		//console.log('录音时长(秒)', params.duration);
		// console.log('录音大小(字节)', params.fileSize);
		//console.log('录音音量百分比(%)', params.vol);
		// console.log('当前录音的总数据([DataView, DataView...])', params.data);
		// console.log('--------------END---------------')
	}

	export default {
		data() {
			return {
				musicRecording_control: false, //浏览器是否支持语音
				musicRecording_open: false, //是否录制声音
				musicRecording_close: false, //是否录制
				musicRecording_duration: 0, //录音时长(秒)
				musicRecording_data: "", //录制文件地址
				musicRecording_upload: false, //是否录制上传
			};
		},
		methods: {
			/**
			 *  获取麦克风权限
			 * */
			getPermission() {
				Recorder.getPermission().then(() => {
					//this.$Message.success('获取权限成功');
					this.musicRecording_control = true;
				}, (error) => {
					this.musicRecording_control = true;
					console.log(`${error.name} : ${error.message}`);
					//alert(`${error.name} : ${error.message}`)
				});
			},
			// 开始录音
			startRecorder() {
				recorder.start().then(() => {
					this.$Message.success('开始录音');
				}, (error) => {
					// 出错了
					console.log(`${error.name} : ${error.message}`);
				});
			},
			// 录音播放
			playRecorder() {
				this.$Message.success('播放录音');
				recorder.play()
			},
			upFile() {
				this.$Message.success('文件上传中...');
				const formData = new FormData()
				const blob = recorder.getWAVBlob() // 获取wav格式音频数据
				// 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
				const newbolb = new Blob([blob], {
					type: 'audio/wav'
				})
				const fileOfBlob = new File([newbolb], new Date().getTime() + '.wav')
				formData.append('fileName', fileOfBlob)
				this.$api.postAPI(
					`default/upload/?`,
					formData).then(res => {
					this.$Message.success('文件上传完成！');
					let data = res.data;
					console.log(data);
					this.$emit('upFile', data.url)
				});
			}
		},
		mounted() {
			this.getPermission()
		}
	};
</script>


<style scoped>
	.samp_info {
		background: #409EFF;
		padding: 1rem 2rem;
		border-radius: 5px;
		color: #ffffff;
	}

	.recording {
		padding-top: 30px;
		height: 200px;
		line-height: 70px;
		text-align: center;
	}

	.samp_info_bin {
		background: #409EFF;
		padding: 5px 10px;
		border-radius: 5px;
		color: #ffffff;
		height: 100px;
	}

	.recording_1 {
		height: 120px;
	}

	.jumbotron_c {
		background: #f3f4f8;
		border-radius: 5px;
		padding: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/tool/upload/upload_voice.vue